export default {
    name: "RecentRenderJobsWidget",
    type: "DataWidget",
    description: "Monitor the status of your recent video generation jobs.",
    roles: ["appUser"],
    widget: {
        title: "Recent Renders",
        size: "large",
        dataProvider: {
            main: {
                rpc: "VideoGeneratorRpc.listRecentJobs",
                params: { limit: 5 }
            }
        },
        fields: [
            { name: "projectName", isTitle: true },
            { 
                name: "status", 
                isSubtitle: true, 
                render: (val, item) => {
                    let badgeClass = 'bg-secondary';
                    if (val === 'completed') badgeClass = 'bg-success';
                    if (val === 'failed') badgeClass = 'bg-danger';
                    if (val === 'in_progress') badgeClass = 'bg-primary';
                    return `<span class="badge ${badgeClass}">${val}</span> ${item.progress ? `(${item.progress}%)` : ''}`;
                }
            },
            { name: "createdAt", isMeta: true, render: (val) => new Date(val).toLocaleString() }
        ],
        noDataMessage: "No render jobs found."
    }
};